import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AuthTokenSelector } from '../../Redux/Auth/selector';
import {
  StudentsRetrieveAllSelectors,
  StudentUpdateSelectors,
  ClassDeleteSelectors,
  StudentsSearchSelectors,
  ResetPasswordSelectors,
} from '../../Redux/Students/selectors';
import {
  retrieveStudentsRowsTotalOffsetRequest,
  defineStudentsSearchParams,
} from '../../Redux/Students/Retrieve/actions';

import { ModalDispatch } from '../../contexts/ModalContext';

import { updateStudentReset } from '../../Redux/Students/Update/actions';

import { deleteStudentRequest, deleteStudentResetState } from '../../Redux/Students/Delete/actions';

import { StudentsInfo } from './StudentsInfo';

import { Table } from '../../components/Table';
import { SearchAndFilter } from '../../components/SearchAndFilter';

import { LoadingDispatch } from '../../contexts/LodingContext';

import { showNotify } from '../../utils/showNotify';
import { SelectItemsPerPage } from '../../components/SelectItemsPerPage';

import { ModalToRegisterStudent } from './ModalToRegisterStudent';
import { ModalToDeleteStudent } from './ModalToDeleteStudent';
import { resetPasswordReset } from '../../Redux/Students/ResetPassword/actions';

function Students() {
  const dispatch = useDispatch();
  const modalDispatch = ModalDispatch();
  const loadingDispatch = LoadingDispatch();
  const [valuePagination, setValuePagination] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const studentsSearch = useSelector(StudentsSearchSelectors);
  const [componentLoaded, setComponentLoaded] = useState(false);
  const [shouldResetPagination, setShouldResetPagination] = useState(false);
  const [dataToEdit, setDataToEdit] = useState();
  const [searchText, setSearchText] = useState('');

  const abortStudentsRetrieveAllRequestController = new AbortController();

  const Titles = ['Data', 'Modificado em', 'Nome', 'Data de nascimento', 'Estado', 'Cidade', 'Escola', 'E-mail'];
  const listOfKeys = [
    { key: 'createdAt', isDate: true },
    { key: 'modifiedAt', isDate: true },
    { key: 'name' },
    { key: 'birthDate', isDate: true },
    { key: 'state' },
    { key: 'city' },
    { key: 'schoolName' },

    { key: 'username' },
  ];

  const authToken = useSelector(AuthTokenSelector);
  const dataOfTable = useSelector(StudentsRetrieveAllSelectors);
  const updateStudent = useSelector(StudentUpdateSelectors);
  const deleteStudent = useSelector(ClassDeleteSelectors);
  const resetPassword = useSelector(ResetPasswordSelectors).resetPasswordReducer

  useEffect(() => {
    setComponentLoaded(true);
    return () => {
      dispatch(defineStudentsSearchParams({ search: '' }));
      abortStudentsRetrieveAllRequestController.abort();
    }
  }, []);

  function updateStudentNotify() {
    let contentNotify;
    let typeNotify;
    if (updateStudent.hasError) {
      typeNotify = 'error';
      contentNotify = 'Ocorreu um erro ao atualizar cadastro do Aluno. Tente novamente :)';
    } else if (updateStudent.data.name) {
      typeNotify = 'success';
      contentNotify = 'Aluno(a) atualizado(a)';
      dispatch(updateStudentReset());
      dispatchDataForTable(valuePagination);
    }
    showNotify(typeNotify, contentNotify);
  }

  function deleteStudentNotify() {
    let contentNotify;
    let typeNotify;
    if (deleteStudent.hasError) {
      typeNotify = 'error';
      contentNotify = 'Ocorreu um erro ao excluir Aluno(a). Tente novamente :)';
    } else if (deleteStudent.deleteSuccess) {
      typeNotify = 'success';
      contentNotify = 'Aluno(a) excluído(a)';
      dispatch(deleteStudentResetState());
      dispatchDataForTable(valuePagination);
    }
    showNotify(typeNotify, contentNotify);
  }

  function resetStudentPasswordNotify() {
    let contentNotify;
    let typeNotify;
    if (resetPassword.hasError) {
      typeNotify = 'error';
      if (resetPassword.errorMsg === 'Unauthorized')
        contentNotify = 'Sua senha está incorreta. Tente novamente :)';
      else
        contentNotify = 'Ocorreu um erro ao atualizar a senha do Aluno. Tente novamente :)';
    } else if (resetPassword.success) {
      typeNotify = 'success';
      contentNotify = 'Senha do(a) aluno(a) atualizada';
    }
    dispatch(resetPasswordReset());
    showNotify(typeNotify, contentNotify);
  }

  const limit = itemsPerPage;
  const search = studentsSearch;

  function dispatchDataForTable(offset) {
    dispatch(retrieveStudentsRowsTotalOffsetRequest(offset, authToken, search, limit, abortStudentsRetrieveAllRequestController.signal));
  }

  useEffect(() => {
    setShouldResetPagination(false);
    dispatchDataForTable(valuePagination);
  }, [valuePagination]);

  useEffect(() => {
    if (valuePagination === 0 && componentLoaded) dispatchDataForTable(valuePagination);
    setShouldResetPagination(true);
    setValuePagination(0);
  }, [itemsPerPage, search]);

  useEffect(() => {
    if (dataToEdit) modalDispatch({ type: 'open', payload: <ModalToRegisterStudent idStudent={dataToEdit.userId} /> });
  }, [dataToEdit]);

  function handleSearch(event) {
    event.preventDefault();
    const search = searchText ? `keyword=${searchText}` : '';
    dispatch(defineStudentsSearchParams({ search }));
  }

  const getItemById = userId => dataOfTable.rows.find(item => item.userId === userId);

  function deleteStudentById(userId) {
    dispatch(deleteStudentRequest({ id: userId, authToken }));
    modalDispatch({ type: '' });
  }

  async function _setDataToEdit(item) {
    if (dataToEdit?.userId === item.userId) {
      modalDispatch({ type: 'open', payload: <ModalToRegisterStudent useForEdit idStudent={item.userId} /> });
    } else setDataToEdit(item);
  }

  async function openModalToDelete(userId) {
    const { userId: idStudent, name } = getItemById(userId);
    const payload = <ModalToDeleteStudent studentName={name} actionIfYes={() => deleteStudentById(idStudent)} />;
    modalDispatch({ type: 'open', payload });
  }

  deleteStudent.isLoading || updateStudent.isLoading || resetPassword.isLoading
    ? loadingDispatch({ type: 'open' })
    : loadingDispatch({ type: '' });

  (deleteStudent.deleteSuccess || deleteStudent.hasError) && deleteStudentNotify();

  return (
    <>
      {(updateStudent.data || updateStudent.hasError) && updateStudentNotify()}
      {(resetPassword.success || resetPassword.hasError) && resetStudentPasswordNotify()}
      <div className="row mb-2">
        <div className="col-xl my-auto mr-auto">
          <h3 className="titlePages">Alunos</h3>
        </div>

        <div className="col-md-auto d-flex flex-row flex-wrap align-center mb-2">
          <SearchAndFilter
            haveFilter={false}
            selectedSearchValue={searchText}
            setSearch={setSearchText}
            inputPlaceholder="Pesquisar por nome..."
            onSubmit={handleSearch}
          />

          <SelectItemsPerPage itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} />
        </div>
      </div>

      <Table
        titles={Titles}
        dataOfTable={dataOfTable}
        keysOfObjectsData={listOfKeys}
        dataKey="userId"
        functionForPagination={setValuePagination}
        shouldResetPagination={shouldResetPagination}
        notColapse
        notColapseFunction={openModalToDelete}
        editButton={item => _setDataToEdit(item)}
        itemsPerPage={itemsPerPage}
      />
    </>
  );
}

export default Students;
